<template>
  <component
    :is="ignoreLabel ? 'div' : 'label'"
    class="app-input-container"
    :class="{ inline, focused, error, warning }"
  >
    <slot name="label">
      <AppInputLabel v-if="label" v-html="label" />
    </slot>

    <slot />
  </component>
</template>

<script>
import AppInputLabel from '@/components/App/Input/Label.vue'

export default {
  name: 'AppInputContainer',

  components: {
    AppInputLabel,
  },

  data() {
    return { focused: false }
  },

  props: {
    error: {
      type: Boolean,
      default: false,
    },

    warning: {
      type: Boolean,
      default: false,
    },

    inline: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      required: false,
    },

    required: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ignoreLabel() {
      return (
        this.$attrs.ignoreLabel ?? this.$attrs['ignore-label'] ?? !this.label
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@use '@/styles/settings.scss' as *;

.app-input-container {
  &,
  > label {
    display: flex;
    flex-direction: column;
  }

  > label {
    width: 100%;
  }

  &.focused {
    :deep(.app-input-label) {
      color: $primaryColor;
    }

    :deep(.app-input-clear-button) {
      > .app-button {
        background-color: $primaryColor;
        color: #fff;
      }
    }
  }

  &.error {
    color: $errorColor;

    :deep(.app-input),
    :deep(.app-input-help-text),
    &.focused :deep(.app-input-label) {
      color: inherit;
    }

    :deep(.app-input-clear-button) {
      > .app-button {
        background-color: $errorColor;
        color: #fff;
      }
    }

    :deep(.app-input) {
      background-color: rgba($errorColor, 0.1);
    }
  }

  &.warning {
    color: $warningColor;

    :deep(.app-input),
    :deep(.app-input-help-text),
    &.focused :deep(.app-input-label) {
      color: inherit;
    }

    :deep(.app-input-clear-button) {
      > .app-button {
        background-color: $warningColor;
        color: #fff;
      }
    }

    :deep(.app-input) {
      background-color: rgba($warningColor, 0.1);
    }
  }

  &.inline {
    &,
    > label {
      flex-direction: row;
      align-items: center;
    }

    :deep(.app-input-label) {
      margin-right: 1rem;
    }

    :deep(.app-input) {
      flex: 1;
    }
  }
}
</style>
